export interface PingPongManagerOptions {
  websocket: WebSocket;
  pingIntervalMs?: number;
  pongTimeoutMs?: number;
  failureCallback: () => void;
  enableLogging?: boolean;
}
export default class PingPongManager {
  private ws: WebSocket;
  private failureCallback: () => void;

  private pingIntervalMs: number;
  private pongTimeoutMs: number;
  private enableLogging: boolean;

  private pongTimers: Map<string, NodeJS.Timeout>;
  private pingIntervalTimer: NodeJS.Timeout | null;

   constructor(options: PingPongManagerOptions) {
       this.ws = options.websocket;
       this.failureCallback = options.failureCallback;
       this.pingIntervalMs = options.pingIntervalMs ?? 1000;
       this.pongTimeoutMs = options.pongTimeoutMs ?? 5000;
       this.enableLogging = options.enableLogging ?? false;
       this.pongTimers = new Map();
       this.pingIntervalTimer = null;
   }

   log(message: string) {
       if (this.enableLogging) {
           console.log(message)
       }
   }

   stopPingsAndCleanup() {
       this.stopPing()
       this.clearPongs()
   }

   clearPongs() {
       for (const timer of this.pongTimers.values()) {
           clearTimeout(timer);
       }
       this.pongTimers.clear();
   }

   startPings() {
       if (this.pingIntervalTimer) {
           this.log('Start Ping: Clearing old ping interval timer')
           clearInterval(this.pingIntervalTimer);
       }

       this.pingIntervalTimer = setInterval(() => {
           this.doPing();
       }, this.pingIntervalMs);
       this.log('Started ping interval timer')
   }

   stopPing() {
       this.log('Stopping pinging')
       if (this.pingIntervalTimer) {
           clearInterval(this.pingIntervalTimer);
           this.pingIntervalTimer = null;
           this.log('Stopped pinging')
       } else {
           this.log('No ping timer to stop')
       }
   }

   doPing() {
       const pingId = crypto.randomUUID();

       try {
           this.ws.send(`ping ${pingId}`);
           this.log(`Sent ping ${pingId}`);
           this.registerPing(pingId);
       } catch (error) {
           console.info('Error sending ping:', error);
           this.failureCallback();
       }
   }

   checkPong(message: string) {
       if (message.startsWith('pong ')) {
           const pongId = message.slice(5);
           this.log(`Received pong ${pongId}`);
           this.registerPong(pongId);
           return true
       }
       return false;
   }

   registerPing(id: string) {
       const timer = setTimeout(() => {
           console.log('Pong timeout')
           this.failureCallback();
       }, this.pongTimeoutMs);

       this.pongTimers.set(id, timer);
   }

   registerPong(id: string) {
       const timer = this.pongTimers.get(id);
       if (timer) {
           clearTimeout(timer);
           this.pongTimers.delete(id);
       } else {
           // This should never happen. If there's a bug here, notify Ben
           console.error(`Received invalid pong id: ${id}`)
       }
   }
}